import {
  AfterViewInit,
  Directive,
  EventEmitter,
  HostListener,
  Inject,
  Input,
  OnChanges,
  Output,
  PLATFORM_ID,
  Renderer2
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { TypographyUtils } from '../utils/typography.utils';

@Directive({
  selector: '[sdIsCollapsible]',
  standalone: true
})
export class SdIsCollapsibleDirective implements AfterViewInit, OnChanges {
  @Input()
  previewPanel: HTMLElement;

  @Input()
  collapsiblePanel: HTMLElement;

  @Input()
  action: HTMLElement;

  @Input()
  isOpen: boolean;

  @Output()
  isOpenChange = new EventEmitter<boolean>();

  @Input()
  limit: number;

  @Input()
  cleanCode = true;

  _ellipsisEl: HTMLSpanElement;
  removeHTMLTags = TypographyUtils.removeHTMLTags;
  truncateHTMLContent = TypographyUtils.truncateHTMLContent;

  constructor(
    @Inject(PLATFORM_ID) private platformId: any,
    private renderer: Renderer2,
  ) {
    this._ellipsisEl = this.renderer.createElement('span');
  }

  ngOnChanges() {
    if (isPlatformBrowser(this.platformId)) {
      if (this.collapsiblePanel && this.action) {
        this.initComp();
      }
    }
  }

  ngAfterViewInit() {
    if (isPlatformBrowser(this.platformId)) {
      setTimeout(() => {
        if (this.collapsiblePanel && this.action) {
          this.initComp();
        }
      }, 0);
    } else {
      this.collapsiblePanel?.remove();
    }
  }

  @HostListener('click', ['$event'])
  onClick(event): void {
    if (this.action?.contains(event.target)) {
      this.toggle();
    }
  }

  initComp() {
    if (this.limit) {
      const fullHtml = this.previewPanel.innerHTML;
      const { preview, remaining } = this.truncateHTMLContent(fullHtml, this.limit);

      this.previewPanel.innerHTML = this.cleanCode ? this.removeHTMLTags(preview) : preview;
      this._ellipsisEl.innerHTML = '...';
      this.renderer.appendChild(this.previewPanel, this._ellipsisEl);

      this.collapsiblePanel.innerHTML = this.cleanCode ? this.removeHTMLTags(remaining) : remaining;

      this.renderer.removeClass(this.action, 'is-hidden');
    }

    this.renderer.addClass(this.collapsiblePanel, 'is-collapsible');
    if (!this.isOpen) {
      this.renderer.addClass(this.collapsiblePanel, 'is-hidden');
    } else {
      this.renderer.removeClass(this.collapsiblePanel, 'is-hidden');
    }
  }

  expand() {
    if (!this.isOpen) {
      this.isOpen = !this.isOpen;
      this.isOpenChange.emit(this.isOpen);
      this.renderer.removeClass(this.collapsiblePanel, 'is-hidden');

      if (this.limit) {
        this.renderer.removeChild(this.previewPanel, this._ellipsisEl);
      }
    }
  }

  collapse() {
    if (this.isOpen) {
      this.isOpen = !this.isOpen;
      this.isOpenChange.emit(this.isOpen);
      this.renderer.addClass(this.collapsiblePanel, 'is-hidden');

      if (this.limit) {
        this.renderer.appendChild(this.previewPanel, this._ellipsisEl);
      }
    }
  }

  toggle() {
    if (this.collapsiblePanel) {
      if (this.isOpen) {
        this.collapse();
      } else {
        this.expand();
        /* A11Y */
        setTimeout(() => {
          this.renderer.setAttribute(
            this.collapsiblePanel?.parentNode as HTMLElement,
            'tabindex',
            '-1',
          );
          (this.collapsiblePanel?.parentNode as HTMLElement).focus();
        });
      }
    }
  }
}
